__turbopack_context__.v({
  "fullpagewrapper": "FullPageSpinner-module-scss-module__CHZOLG__fullpagewrapper",
});
